    //スマホメニュー
    $(function () {
      $('.p-sp-header__trigger-inner').on('click', function () {
        $(this).toggleClass('active');
        $('.p-sp-header__nav').fadeToggle('');
      });
    });